import RadioDots from "./RadioDots";
import { COLORS, SIZES } from "./utilities";

export { COLORS, SIZES };
export default RadioDots;
